import React from "react";
import ReactDOMServer from "react-dom/server";
import {
  InfoTable,
  SectionTitle,
  getPassengerSummary,
  getRouteSummary,
} from "./BnplFreezePDFUtils";

export default function BnplFreezePDFOrderSummaryStatic({ freeze, flight }) {
  const airline =
    flight?.flights?.[0]?.airlineName || flight?.flights?.[0]?.airline || "-";
  const cabin = flight?.flights?.[0]?.cabinClass || "-";

  const content = (
    <table className="w-full mb-2" cellPadding="0" cellSpacing="0">
      <tbody>
        <tr>
          <td>
            <SectionTitle>1. Order Summary</SectionTitle>
            <InfoTable
              rows={[
                { label: "BNPL Order", value: freeze?.reference },
                {
                  label: "Flight Order",
                  value: flight?.orderId || flight?.pnr,
                },
                { label: "Booking Reference", value: flight?.bookingId },
                { label: "Airline PNR", value: flight?.pnr },
                { label: "Supplier", value: flight?.supplier },
                { label: "Airline", value: airline },
                {
                  label: "Passenger(s)",
                  value: getPassengerSummary(flight?.travelers),
                },
                { label: "Route", value: getRouteSummary(flight) },
                { label: "Cabin", value: cabin },
                { label: "Fare Type", value: flight?.fareType },
                { label: "Ticket Status", value: flight?.status },
                {
                  label: "Refundable",
                  value: flight?.isRefundable ? "Yes" : "No",
                },
                {
                  label: "Changeable",
                  value: flight?.isChangeable ? "Yes" : "No",
                },
              ]}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );

  return ReactDOMServer.renderToStaticMarkup(content);
}
